import React, { Dispatch, SetStateAction } from "react";
import { Box } from "@mui/material";
import Select from "@common/components/Select";
import MenuItem from "@common/components/MenuItem";
import { archivedDeviceTimeFilter } from "@services/devices/types";
import { useTranslation } from "react-i18next";

type ArchivedDeviceFiltersProps = {
  timeFilter?: number;
  setTimeFilter?: Dispatch<SetStateAction<number>>;
};

const ArchivedDeviceFilters = (props: ArchivedDeviceFiltersProps) => {
  const { timeFilter, setTimeFilter } = props;
  const { t } = useTranslation();

  return (
    <Box sx={{ my: 2 }}>
      <Select
        label="Time"
        value={timeFilter}
        onChange={(evt) => {
          setTimeFilter && setTimeFilter(evt.target.value as number);
        }}
      >
        {archivedDeviceTimeFilter.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {t(label)}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default ArchivedDeviceFilters;
